import { SchedulingEventType } from '@principle-theorem/principle-core/interfaces';
import {
  ISerialisedDocumentReference,
  ISerialisedTimestamp,
} from '@principle-theorem/shared';
import {
  IBigQueryFirestoreModel,
  IBigQueryReffable,
  ITimestampedDimension,
} from './common';

export interface ISchedulingEventDimension
  extends IBigQueryReffable,
    IBigQueryFirestoreModel,
    ITimestampedDimension {
  scheduledAt: ISerialisedTimestamp;
  scheduledByStaffer?: ISerialisedDocumentReference;
  scheduledByPractice: ISerialisedDocumentReference;
  eventType: SchedulingEventType;
  reason?: ISerialisedDocumentReference;
  reasonSetManually: boolean;
  schedulingConditions: IBigQuerySchedulingEventConditions;
  eventBefore?: IBigQuerySchedulingEventSnapshot;
  eventAfter?: IBigQuerySchedulingEventSnapshot;
}

export interface IBigQuerySchedulingEventSnapshot {
  practitionerRef: ISerialisedDocumentReference;
  practiceRef: ISerialisedDocumentReference;
  from: ISerialisedTimestamp;
  to: ISerialisedTimestamp;
}

export interface IBigQuerySchedulingEventConditions {
  eventType: SchedulingEventType;
  moveToSameDayDefault: boolean;
  fillGapDefault: boolean;
  hrsBeforeAppointmentWasScheduled?: number;
  hrsBeforeAppointmentScheduledFor?: number;
}
